// import HeaderRating from './components/HeaderRating';
import HeaderNav from './components/HeaderNav';
// import HeaderPhone from './components/HeaderPhone';
import HeaderDropdown from './components/HeaderDropdown';
import useWindowSize from '@customHooks/useWindowSize';
import { memo } from 'react';
import './index.scss';

const InfoHeader = () => {
  const { windowWidth } = useWindowSize();
  return (
    <header className='info-header'>
      {windowWidth >= 1280 && (
        <>
          <HeaderNav />
          {/* <HeaderPhone /> */}
          {/* <HeaderRating /> */}
        </>
      )}
      <HeaderDropdown />
      {/* {windowWidth >= 768 && windowWidth < 1280 && <HeaderPhone />} */}
    </header>
  );
};
export default memo(InfoHeader);
